<ion-header class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ng-container>
            <ion-title>{{ 'SELECT_KEYWORDS_MODAL_HEADER' | translate }}</ion-title>
            <ion-buttons slot="end">
                <ion-button (click)="backClicked()">
                    <ion-icon slot="icon-only"
                              color="dark"
                              name="close"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ng-container>
    </ion-toolbar>
</ion-header>

<div class="scroll-box ion-padding">
    <div class="filter-card"
         *ngIf="!loading">

        <div class="filter-box">

            <ion-col class="ion-no-padding">
                <ng-container *ngIf="event.matching_status && user">
                    <hr class="full" />

                    <ng-container *ngFor="let container of event.containers; let c = index">
                        <hr class="full"
                            *ngIf="c > 0">
                        <h4><strong>{{c+1}}.</strong> {{ container.translate(userLang, event.default_locale).name }}</h4>
                        <ion-row class="keyword-box ion-no-padding">

                            <ng-container *ngFor="let column of (container.columns === 2 ? [1,2] : [1])">
                                <ion-col class="multi-columns ion-no-padding"
                                         size="{{ container.columns === 2 ? '6' : '12' }}">
                                    <br *ngIf="plt.sizeSm && column == 2">
                                    <h5 *ngIf="container.columns === 2">{{ container.translate(userLang, event.default_locale)['column_' + column + '_name'] }}</h5>

                                    <!-- Keywords -->
                                    <div class="keyword-list">
                                        <ng-container *ngFor="let keyword of container.keywords">
                                            <ng-container *ngIf="keyword.isValid(event.available_locales, user.selected_participant_id)">
                                                <ion-chip *ngIf="keyword.approved_at || !keyword.participant_id"
                                                          [ngClass]="{'enabled': isSelected(column, keyword)}"
                                                          (click)="toggleKeyword(column, keyword)">
                                                    <ion-label>
                                                        {{ keyword.translate(userLang, event.default_locale).name | cut: 80 }}
                                                        <ion-spinner *ngIf="keyword.loading == column"
                                                                     name="dots"></ion-spinner>
                                                    </ion-label>
                                                </ion-chip>
                                            </ng-container>
                                        </ng-container>
                                    </div>

                                </ion-col>
                            </ng-container>
                        </ion-row>

                    </ng-container>
                </ng-container>

                <!-- <ion-row class="ion-no-padding">
                        <ion-col class="ion-no-padding ion-text-right">
                            <ion-button (click)="seeResults()">
                                {{ 'BUTTON_SEE_RESULTS' | translate }}
                            </ion-button>
                        </ion-col>
                    </ion-row> -->
            </ion-col>

        </div>
    </div>
</div>

<ion-footer>
    <ion-row class="ion-no-padding">
        <ion-col class="ion-no-padding ion-text-right">
            <ion-button (click)="seeResults()">
                {{ 'BUTTON_OK' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>

<ng-container *ngIf="loading">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>